import styled, { css } from 'styled-components'

export const nothing = styled.div``

export const AuthorDetailsWrapper = styled.div`
  margin: 2rem;
  margin-top: 0;

  ${({ theme }) => css`
    ${theme.breakpoints.down.md} {
      margin: 0 1rem;
      margin-bottom: 2rem;
    }
  `}
`
